import {
  Collapse,
  Grid,
  TextField,
  Button,
  Box,
  Chip,
  Typography,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function Filter({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) {
  return (
    <Collapse in={filterOpen} timeout="auto" unmountOnExit>
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Group Name"
              value={filterData.group_name || ""}
              onChange={handleChangeFilter("group_name")}
              fullWidth
              size="small"
              placeholder="Enter group name"
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Time"
              value={filterData.time || ""}
              onChange={handleChangeFilter("time")}
              fullWidth
              size="small"
              placeholder="Enter time (e.g., 10:00 AM)"
            />
          </Grid> */}
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                onClick={handleClearFilters}
                sx={{
                  minWidth: "80px",
                }}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                onClick={handleFilter}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: "#7152F3",
                  "&:hover": { backgroundColor: "#5c34fa" },
                  minWidth: "100px",
                }}
              >
                Filter
              </Button>
            </Box>
          </Grid>
        </Grid>

        {Object.keys(submittedData).length > 0 && (
          <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ color: "#48505E" }}>
              Applied Filters:
            </Typography>
            {Object.entries(submittedData).map(([key, value]) => (
              <Chip
                key={key}
                label={`${key === 'group_name' ? 'Group' : key}: ${value}`}
                onDelete={() => handleRemove(key)}
                size="small"
                sx={{
                  backgroundColor: "#F0F0F0",
                  "& .MuiChip-deleteIcon": {
                    color: "#7152F3",
                  },
                }}
              />
            ))}
          </Box>
        )}
      </Box>
    </Collapse>
  );
}